import {NgModule} from '@angular/core';
import {PanelToolsComponent} from './panel-tools.component';
import {DynamicFieldsModule} from '@app/modules/dynamic-fields/dynamic-fields.module';
import {FlexLayoutModule} from '@angular/flex-layout';
import {MatLegacyMenuModule as MatMenuModule} from '@angular/material/legacy-menu';
import {GlobalModule} from '@app/core/global.module';
import {ButtonModule} from '../button/modules/button.module';

@NgModule({
    declarations: [PanelToolsComponent],
    exports: [
        PanelToolsComponent
    ],
    imports: [
        DynamicFieldsModule,
        FlexLayoutModule,
        MatMenuModule,
        GlobalModule,
        ButtonModule
    ]
})
export class PanelToolsModule {
}
